import { DemoConstants } from './demo.constants'
import { IDemoActions, IDemoState } from './demo.types'

const navigation = [
  {
    key: 'timeline',
    component: 'navButton',
    label: 'Timeline',
    path: '/timeline',
  },
  {
    key: 'home',
    component: 'navButton',
    label: 'Home',
    path: '/home',
  },
  {
    key: 'vitals',
    component: 'navButton',
    label: 'Vitals',
    path: '/vitals',
  },
  {
    key: 'login',
    component: 'navButton',
    label: 'Login',
    path: '/login',
  },
]

export const initialDemoState: IDemoState = {
  navigation: navigation,
  airwayButtonCount: 0,
}

export function demoReducer(state: IDemoState = initialDemoState, action: IDemoActions): IDemoState {
  switch (action.type) {
    case DemoConstants.UPDATE_AIRWAY:
      return { ...state, airwayButtonCount: state.airwayButtonCount + 1 }
    default:
      return state
  }
}
